import stream from "mithril/stream";
import merge from "./merge";
import m from "mithril";

export default (initial, onupdate) => {
	if (!initial) initial = {};
	const Functions = (u) => {
		return {
			Update: (s) => {
				u(s);
				if (onupdate) onupdate(states(), s);
				m.redraw();
			},
		};
	};
	const u = stream();
	const states = stream.scan(merge, initial, u);
	const functions = Functions(u);

	return {
		states: states,
		update: (s) => {
			functions.Update(s);
			return states();
		},
	};
};
